import { resolveMediaPath } from './resolve-media-path';

export interface DownloadFileResult {
  success: boolean;
  error?: string;
}

const getFallbackFileName = (filePath: string): string => {
  const pathWithoutQuery = filePath.split(/[?#]/, 1)[0];
  const candidate = pathWithoutQuery?.split('/').pop();
  return candidate !== undefined && candidate !== '' ? candidate : 'download';
};

export const downloadFile = async (
  filePath?: string | null,
  fileName?: string | null
): Promise<DownloadFileResult> => {
  const normalizedPath = filePath?.trim();

  if (!normalizedPath || typeof document === 'undefined') {
    return { success: false, error: 'Download URL is unavailable' };
  }

  const resolvedPath = resolveMediaPath(normalizedPath);
  if (!resolvedPath) {
    return { success: false, error: 'Download URL is unavailable' };
  }

  const link = document.createElement('a');

  try {
    const downloadUrl = new URL(resolvedPath, window.location.href);
    if (downloadUrl.href === window.location.href) {
      return { success: false, error: 'Download URL points to current page' };
    }

    link.href = downloadUrl.href;
    link.download = fileName ?? getFallbackFileName(normalizedPath);
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();

    return { success: true };
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Download failed',
    };
  } finally {
    link.remove();
  }
};
